import React from 'react'
import { CategoryContainer, CategoryItem, CategoryList, CategorySection, PreFooterHead } from '../../../../StyledComponents'
import { Col, Row } from 'reactstrap';

const PreFooter = () => {

    const categories = [
        {
          title: "Toys and Hobbies",
          subdata: [
            "Toys",
            "Creative and Hobby",
            "Fancy Costumes",
            "Tricycles",
            "Outdoor Toys"
          ]
        },
        {
            title: "Books and Stationary",
            subdata: [
              "Books",
              "E-books",
              "Notebooks",
              "English Books",
              "Audiobooks",
              "Old Books",
              "Diaries",
              "Colors",
              "Art and Sketch Notebooks"
            ]
          },
          {
            title: "Outdoor, Travel and Sports",
            subdata: [
              "Sports Wear",
              "Accessories",
              "Camping and Outdoor",
              "Travel",
              "Camping and Outdoor"
            ]
          },
          {
            title: "FASHION",
            subdata: [
              "Women Fashion",
              "Women Clothing",
              "Women Shoes",
              "Men Clothing",
              "Men Shoes",
              "Accessories",
              "Jewelry and Watches",
              "Baby Garments"
            ]
          },
          {
            title: "Kitchen",
            subdata: [
              "Cooking and Dining",
              "Pans",
              "BBQs",
              "Cutlery",
              "Storage Boxes",
              "Trash Cans"
            ]
          },
          {
            title: "Furniture",
            subdata: [
              "Table Chairs",
              "Sofas",
              "Beds",
              "Dining Table"
            ]
          },
          {
            title: "Computer and Electronics",
            subdata: [
              "Computer/PC",
              "Tablets",
              "LEDs",
              "Kitchen Appliances",
              "Cameras",
              "Cleaners",
              "Washing Machines",
              "Personal Care"
            ]
          },
          {
            title: "Office and School",
            subdata: [
              "Uniforms",
              "Stationary",
              "Office Supplies",
              "School Supplies"
            ]
          },
          {
            title: "Living",
            subdata: [
              "Living",
              "Furniture",
              "Relief",
              "Home Accessories"
            ]
          },
          {
            title: "Garden",
            subdata: [
              "Garden tools",
              "Garden decor",
              "Plants",
            ]
          },
          {
            title: "Drinks and delicatessen",
            subdata: [
              "Drinks",
              "Tea and coffee",
              "Chocolate",
              "Delicatessen",
            ]
          },
      ];

      

  return (
    <>
        <div className='p-2'>
            <PreFooterHead>Find Everything at Maelano</PreFooterHead>
            <div className='p-4'>
            <Row>
            {categories.map((category, index) => (
             <Col xl="2" lg="2" md="4" sm="6" xs="12" key={index} className="mb-4">
             <div className="category-section">
               <h6 style={{ textTransform: 'uppercase' }}>{category.title}</h6>
               <ul className="category-list">
                 {category.subdata.map((subitem, subindex) => (
                   <li key={subindex} className="category-item">{subitem}</li>
                 ))}
               </ul>
             </div>
           </Col>           
            ))}
          </Row>

{/* <CategoryContainer>
    {categories.map((category, index) => (
      <CategorySection key={index}>
        <h5>{category.title}</h5>
        <CategoryList>
          {category.subdata.map((subitem, subindex) => (
            <CategoryItem key={subindex}>{subitem}</CategoryItem>
          ))}
        </CategoryList>
      </CategorySection>
    ))}
  </CategoryContainer> */}




            </div>
        </div>
    </>
  )
}

export default PreFooter